<header class="header" [ngClass]="headerTheme()">
  <div class="layout">
    <a [routerLink]="'/'" class="logo">
      <img src="assets/img/logo.svg" alt="Pædagogernes Pension" height="36" width="220" class="logo-img">
    </a>
    <div class="header-menu">
      <app-header-menu></app-header-menu>
    </div>
    <button
      class="header-menu__btn"
      type="button"
      aria-label="Toggle sidenav"
      mat-icon-button
      (click)="toggleMenu()">
      <mat-icon aria-label="Side nav toggle icon">{{ menuToggleState() ? 'close' : 'menu' }}</mat-icon>
    </button>
  </div>
</header>
@if (menuToggleState()) {
  <app-side-menu @container>
    <app-header-menu></app-header-menu>
  </app-side-menu>
}
